"use client";

import { useNavigate } from "react-router";
import { useOsActionsOptional } from "@/components/ui/os-layout/OsContext";
import { openArtifactById } from "@/components/artifacts/openArtifactDestination";
import { useOpenWindow } from "@/components/ui/os-layout/useWindow";
import { focusEntityInList } from "./entityListFocus";
import { openEntityPreview } from "./entityPreviewOpen";
import type { ChatEntityPreviewEmbed, EntityPreviewEntityType } from "./types";

export function useEntityPreviewNavigation() {
  const navigate = useNavigate();
  const osActions = useOsActionsOptional();
  const openWindow = useOpenWindow();
  const inOsLayout = Boolean(osActions);

  const openPreview = (embed: ChatEntityPreviewEmbed) => {
    openEntityPreview(embed, {
      navigate,
      openWindow,
      inOsLayout,
    });
  };

  const focusInList = (entityType: EntityPreviewEntityType, id: string, title?: string) => {
    if (entityType === "artifact") {
      void openArtifactById(id, openWindow, { mode: "view", title });
      return;
    }
    focusEntityInList(entityType, id, {
      navigate,
      openWindow,
      inOsLayout,
    });
  };

  return { openPreview, focusInList };
}
